import type { AiExecutionGraph } from '../../../../types/aiOperational'
import type { XRayAnchor, XRayEdge } from '../xrayTypes'

export interface AiResolverInput {
  nodeId?: string
  executionGraph?: AiExecutionGraph | null
  sliceId?: string
}

export const resolveAiAnchor = (input: AiResolverInput): XRayAnchor => {
  const { nodeId, executionGraph } = input
  const page = 'ai'

  if (!executionGraph || !executionGraph.steps || !executionGraph.dependencies) {
    return {
      id: nodeId || 'canvas',
      page,
      screenPosition: null,
      edges: [],
      destinations: [],
    }
  }

  const edges: XRayEdge[] = []

  // If specific nodeId is given, look for its prerequisites
  if (nodeId) {
    // A step may have id matching nodeId or graph_${nodeId} or planStepId === nodeId
    const step = executionGraph.steps.find(
      (s) => s.id === nodeId || s.planStepId === nodeId || s.id === `graph_${nodeId}`,
    )

    if (step) {
      // Find dependencies where toStepId === step.planStepId or toStepId === step.id
      const prereqs = executionGraph.dependencies.filter(
        (dep) => dep.toStepId === step.planStepId || dep.toStepId === step.id,
      )

      for (const dep of prereqs) {
        edges.push({
          fromId: dep.fromStepId,
          toId: step.id,
          kind: 'execution-prereq',
          label: dep.description || dep.kind,
        })
      }
    }
  } else {
    // Canvas-level: resolve all dependencies in the execution graph
    for (const dep of executionGraph.dependencies) {
      edges.push({
        fromId: dep.fromStepId,
        toId: dep.toStepId,
        kind: 'execution-prereq',
        label: dep.description || dep.kind,
      })
    }
  }

  return {
    id: nodeId || 'canvas',
    page,
    screenPosition: null,
    edges,
    destinations: [],
  }
}
